import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'

let isRedirectingToLogin = false

// 登录态失效时静默清理凭证并返回登录页，避免把 401/403 当普通错误提示。
function exitExpiredLogin() {
    localStorage.removeItem('token')
    if (isRedirectingToLogin || router.currentRoute.path === '/login') {
        return
    }
    isRedirectingToLogin = true
    router.replace('/login').catch(() => {})
}

// 创建 axios 实例
// baseURL：开发环境走 /api（vue.config.js 代理到本地 3000）；
// 生产构建通过 .env.production 的 VUE_APP_API_BASE_URL 覆盖为线上域名。
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
    timeout: 6000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 约定 code 200 为成功
        if (res.code !== 200) {
            message.error(res.msg || 'Error')
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    error => {
        const status = error.response && error.response.status
        if (status === 401 || status === 403) {
            exitExpiredLogin()
        } else {
            message.error(error.message)
        }
        return Promise.reject(error)
    }
)

export default service
